export const REVIEW_TASK_STATUS = {
  AWAITING_REVIEW: -1,
  COMPLETED: 0,
  ACTIONABLE: 1,
};

export const REVIEW_TASK_KIND = {
  FIELD_CLARIFICATION: 0,
  EXTRA_QUESTION: 1,
  DOCUMENT_REQUEST: 2,
};

export const REVIEW_VISIBLE_TASK_STATUSES = [
  REVIEW_TASK_STATUS.COMPLETED,
  REVIEW_TASK_STATUS.ACTIONABLE,
];

export const REVIEW_FALLBACK_GROUP_LABEL = "Other Requested Items";
